import { render } from "./OfferingInvest.vue?vue&type=template&id=72d31527&scoped=true"
import script from "./OfferingInvest.vue?vue&type=script&lang=js"
export * from "./OfferingInvest.vue?vue&type=script&lang=js"

import "./OfferingInvest.vue?vue&type=style&index=0&id=72d31527&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72d31527"

export default script